/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Section_3_HeadingInputs */

const en_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance without the tradeoff`)
};

const es_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento sin la falsa elección`)
};

const de_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung ohne Kompromiss`)
};

const zh_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需取舍的出色表现`)
};

const ar_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أداء بلا مقايضة زائفة`)
};

const fr_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La performance sans compromis`)
};

const vi_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu suất không phải đánh đổi`)
};

const sw_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utendaji bila kulazimika kuchagua kimoja`)
};

const th_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสิทธิภาพโดยไม่ต้องแลก`)
};

const bs_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans bez kompromisa`)
};

const ja_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`妥協のないパフォーマンス`)
};

const ko_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타협 없는 경기력`)
};

const pt_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho sem concessões`)
};

const it_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni senza compromessi`)
};

const sv_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestation utan kompromisser`)
};

const nl_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatie zonder compromis`)
};

const da_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Præstation uden kompromis`)
};

const nb_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjon uten kompromiss`)
};

const fi_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suorituskykyä ilman kompromisseja`)
};

const pl_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik bez kompromisów`)
};

const ru_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результат без компромиссов`)
};

const tr_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödün vermeden performans`)
};

const hi_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिना समझौते के प्रदर्शन`)
};

const id_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performa tanpa kompromi`)
};

const ms_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasi tanpa pengorbanan`)
};

const cs_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výkon bez kompromisů`)
};

const el_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Απόδοση χωρίς συμβιβασμούς`)
};

const he_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביצועים בלי פשרה`)
};

const af_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasie sonder die afweging`)
};

const hu_injury_content_section_3_heading = /** @type {(inputs: Injury_Content_Section_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmény kompromisszumok nélkül`)
};

/**
* | output |
* | --- |
* | "Performance without the tradeoff" |
*
* @param {Injury_Content_Section_3_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_section_3_heading = /** @type {((inputs?: Injury_Content_Section_3_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Section_3_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_section_3_heading(inputs)
	if (locale === "de") return de_injury_content_section_3_heading(inputs)
	if (locale === "zh") return zh_injury_content_section_3_heading(inputs)
	if (locale === "ar") return ar_injury_content_section_3_heading(inputs)
	if (locale === "fr") return fr_injury_content_section_3_heading(inputs)
	if (locale === "vi") return vi_injury_content_section_3_heading(inputs)
	if (locale === "sw") return sw_injury_content_section_3_heading(inputs)
	if (locale === "th") return th_injury_content_section_3_heading(inputs)
	if (locale === "bs") return bs_injury_content_section_3_heading(inputs)
	if (locale === "ja") return ja_injury_content_section_3_heading(inputs)
	if (locale === "ko") return ko_injury_content_section_3_heading(inputs)
	if (locale === "pt") return pt_injury_content_section_3_heading(inputs)
	if (locale === "it") return it_injury_content_section_3_heading(inputs)
	if (locale === "sv") return sv_injury_content_section_3_heading(inputs)
	if (locale === "nl") return nl_injury_content_section_3_heading(inputs)
	if (locale === "da") return da_injury_content_section_3_heading(inputs)
	if (locale === "nb") return nb_injury_content_section_3_heading(inputs)
	if (locale === "fi") return fi_injury_content_section_3_heading(inputs)
	if (locale === "pl") return pl_injury_content_section_3_heading(inputs)
	if (locale === "ru") return ru_injury_content_section_3_heading(inputs)
	if (locale === "tr") return tr_injury_content_section_3_heading(inputs)
	if (locale === "hi") return hi_injury_content_section_3_heading(inputs)
	if (locale === "id") return id_injury_content_section_3_heading(inputs)
	if (locale === "ms") return ms_injury_content_section_3_heading(inputs)
	if (locale === "cs") return cs_injury_content_section_3_heading(inputs)
	if (locale === "el") return el_injury_content_section_3_heading(inputs)
	if (locale === "he") return he_injury_content_section_3_heading(inputs)
	if (locale === "af") return af_injury_content_section_3_heading(inputs)
	if (locale === "hu") return hu_injury_content_section_3_heading(inputs)
	return en_injury_content_section_3_heading(inputs)
});